<div class="container">
    <div class="row administration">
        <div class="col-md-3 col-lg-2 administration-left">
            <div class="client-dd" *ngIf="true">
                <app-alight-drop-down [group]="batchAlertService.adminForm" [controlName]="'clientId'" [required]="false"
                    description="clientName" (change)="onClientChange($event)" label="Select a Client*" [value]="'clientId'"
                     [list]="customerService.clients">
                </app-alight-drop-down>
            </div>
            <span class="section-divider"></span>
            <div class="administration-left-nav pos-relative">

                <section *ngIf="false" class="error-wrapper">
                    <f-alert variant="error" class="error-without-heading">
                        <p class="full-width">
                            <!-- {{ errorMsg}} -->
                        </p>
                    </f-alert>

                </section>

                <div class="batch-nav">
                                 
                      <ul class="batch-links">
                        <li *ngFor="let menu of batchAlertService.leftNavBatchMenu" [ngClass]="{'active': menu.isActive}">
                          <button title= {{menu.title}} (click)="onLeftNavSelectionChange(menu)">
                            <i [class]="menu.icon"></i> {{ menu.title }}
                          </button>
                        </li>
                      </ul>

                </div>


            </div>

            <div>
            </div>
        </div>
        <div class="col-md-9 col-lg-10 post-relative administration-right">

            <app-admin-filter (selectedRow)="rowSelection($event)" class="admin-filter" *ngIf="batchAlertService.openCurrentBatchFilterDialog"></app-admin-filter>
                  
            

    <!-- create-batch-alert   -->
    <div class="" *ngIf="isBatchAlertActive(CREATE)" >
         <app-create-batch-alert [alertTypes]="alertTypes"></app-create-batch-alert>
    </div>
        

    <!-- Current Batch ALert-->
        

        <!-- Batch Alert Table starts here -->
            <div class="row "  *ngIf="isBatchAlertActive(CURRENT) || isBatchAlertActive(DELETE) || isBatchAlertActive(ARCHIVED)">
                <f-data-card class="col-md-12 admin-details">
                    <div  *ngIf="isBatchAlertActive(CURRENT)" >
                        <app-current-batch-alert [selectedRow]="selectedRow"></app-current-batch-alert>  
                    </div>

                    <div *ngIf="isBatchAlertActive(DELETE)">
                        <app-delete-batch-table></app-delete-batch-table>
                    </div>

                    <div *ngIf="isBatchAlertActive(ARCHIVED)">
                       
                        <app-archived-batch-alert></app-archived-batch-alert>
                       
                    </div>
                       
                </f-data-card>
            </div>            
        </div>
      </div>
      
</div>




